/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { IDefaMediaGalleryViewProps } from './defa-media-gallery';

export default (props: IDefaMediaGalleryViewProps) => {
    return (
        <Module {...props.ModuleProps} ref={props.componentRef}>
            <Node {...props.MediaGalleryContainerProps}>{props.slideshow}</Node>
            {props.zoomedInImage}
        </Module>
    );
};
